import { PnlOperationConfig, SwapBook } from './pnlOperations.types';

const BASE = '/paper-app';

export const FUTURES_CONFIG: PnlOperationConfig = {
  key: 'FUTURES',
  type: 'FUTURES',
  title: 'Futures P&L',
  description: 'Run futures P&L calculations for all books.',
  endpoint: `${BASE}/run-daily-future-open-pnl-optimized/`,
  buttonLabel: 'Run Futures P&L',
};

export const SWAP_BOOKS: SwapBook[] = ['BGM', 'MM', 'OPS', 'CR2', 'FFA'];

export const SWAP_CONFIGS: PnlOperationConfig[] = SWAP_BOOKS.map((book) => ({
  key: book,
  type: 'SWAPS',
  book,
  title: book,
  description: `Run ${book} swaps P&L`,
  endpoint: `${BASE}/${book.toLowerCase()}-swaps-optimised-cloud-v4`,
  buttonLabel: `Run ${book}`,
}));

export const CUSTOMER_CONFIG: PnlOperationConfig = {
  key: 'CUSTOMER',
  type: 'CUSTOMER',
  title: 'Customer P&L',
  description: 'Run customer-level P&L calculation after swaps P&L.',
  endpoint: `${BASE}/customer-bilateral-swaps-pnl-cloud-v4`,
  buttonLabel: 'Run Customer P&L',
};

export const BOOK_COLORS: Record<string, { bg: string; fg: string }> = {
  BGM: { bg: '#dbeafe', fg: '#1d4ed8' },
  MM: { bg: '#dcfce7', fg: '#15803d' },
  OPS: { bg: '#ede9fe', fg: '#6d28d9' },
  CR2: { bg: '#fef3c7', fg: '#b45309' },
  FFA: { bg: '#fee2e2', fg: '#b91c1c' },
};

export const HISTORY_LIMIT = 50;